import i18next from 'i18next';
import * as yup from 'yup';

const validations = yup.object().shape({
  userName: yup.string().required(i18next.t('common.validations.nameRequired'))
});
export default validations;
